var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFaceShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.107,
    x2: 218.107,
    y1: 470,
    y2: 512.012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.655,
    x2: 287.655,
    y1: 519,
    y2: 413.981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.035,
    x2: 88.06,
    xlinkHref: "#lg1",
    y1: 241.579,
    y2: 287.604
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-1 0 0 1 851.222 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 419.641,
    x2: 465.666,
    xlinkHref: "#lg1",
    y1: 241.579,
    y2: 287.604
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc2b5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89580"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.758,
    x2: 413.758,
    xlinkHref: "#lg2",
    y1: 272.178,
    y2: 269.511
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.497,
    x2: 410.12,
    xlinkHref: "#lg1",
    y1: 251.75,
    y2: 251.75
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.407,
    x2: 66.407,
    xlinkHref: "#lg2",
    y1: 257.042,
    y2: 272.042
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.975,
    x2: 199.531,
    xlinkHref: "#lg3",
    y1: 235.302,
    y2: 235.302
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.086,
    x2: 347.642,
    xlinkHref: "#lg3",
    y1: 235.302,
    y2: 235.302
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.892,
    x2: 413.655,
    xlinkHref: "#lg3",
    y1: 43.083,
    y2: 155.847
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(1 0 -.177 1 28.889 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 114.75,
    x2: 259.639,
    xlinkHref: "#lg3",
    y1: 47.075,
    y2: 191.964
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.808,
    x2: 236.808,
    xlinkHref: "#lg2",
    y1: 246.667,
    y2: 343.333
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cf8d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4165,
    stopColor: "#5eccb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008b81"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.393,
    x2: 338.133,
    xlinkHref: "#lg4",
    y1: 283.409,
    y2: 523.059
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5de1c4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#037e73"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.131,
    x2: 357.464,
    xlinkHref: "#lg5",
    y1: 288.279,
    y2: 490.279
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.569,
    x2: 244.902,
    xlinkHref: "#lg5",
    y1: 395.821,
    y2: 312.487
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.716,
    x2: 75.201,
    xlinkHref: "#lg6",
    y1: 258.167,
    y2: 258.167
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.383,
    x2: 430.501,
    xlinkHref: "#lg6",
    y1: 258.167,
    y2: 258.167
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.133,
    x2: 238.133,
    xlinkHref: "#lg6",
    y1: 276.865,
    y2: 318.336
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.133,
    x2: 238.133,
    xlinkHref: "#lg6",
    y1: 287.528,
    y2: 268.379
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.689,
    x2: 327.684,
    y1: 292.586,
    y2: 555.073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc",
    stopOpacity: 0.823
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.822,
    x2: 449.21,
    y1: 165.691,
    y2: 515.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff",
    stopOpacity: 0
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3432,
    stopColor: "#cde0f3",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    stopColor: "#92bae4",
    stopOpacity: 0.787
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.981,
    x2: 244.981,
    xlinkHref: "#lg7",
    y1: 280.156,
    y2: 158.071
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.808,
    x2: 236.808,
    xlinkHref: "#lg8",
    y1: 151.628,
    y2: 193.869
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.808,
    x2: 234.808,
    xlinkHref: "#lg8",
    y1: 189,
    y2: 173
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.829,
    x2: 475.86,
    xlinkHref: "#lg6",
    y1: 352.829,
    y2: 475.86
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.504,
    x2: 414.504,
    xlinkHref: "#lg7",
    y1: 456.667,
    y2: 503.338
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.484,
    x2: 430.567,
    y1: 471.516,
    y2: 412.599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bacdf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.016,
    x2: 466.64,
    xlinkHref: "#lg4",
    y1: 364.048,
    y2: 448.671
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m308.707 434.753c-44.52-28.316-99.278-28.316-143.797-.001-10.674 6.789-22.068 12.035-33.9 15.606-5.637 1.701-11.649 2.404-17.673 2.456-41.638.36-80.199 13.743-108.68 35.694-9.052 6.976-4.01 21.492 7.418 21.492h399.776c27.621 0 33.888-38.71 7.683-47.442-18.4-6.131-38.443-9.564-59.255-9.744-6.025-.052-12.037-.755-17.674-2.456-11.832-3.57-23.224-8.816-33.898-15.605z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.279 452.815c-6.025-.052-12.037-.755-17.674-2.456-11.831-3.57-23.224-8.816-33.898-15.605h-.001c-44.519-28.315-99.278-28.315-143.796 0-8.22 5.228-16.869 9.531-25.814 12.868l62.379 62.378h210.376c27.621 0 33.888-38.71 7.683-47.442-18.4-6.13-38.443-9.564-59.255-9.743z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.197 266.319c0-27.061 18.785-49.735 44.026-55.693 6.747-1.593 13.197 3.625 13.197 10.557v90.272c0 6.932-6.45 12.15-13.197 10.557-25.241-5.959-44.026-28.632-44.026-55.693z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.419 266.319c0-27.061-18.785-49.735-44.026-55.693-6.747-1.593-13.197 3.625-13.197 10.557v90.272c0 6.932 6.45 12.15 13.197 10.557 25.242-5.959 44.026-28.632 44.026-55.693z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.743 266.32c0 27.06-18.78 49.73-44.02 55.69-6.75 1.59-13.2-3.62-13.2-10.56v-4.52c.48.17.97.31 1.48.4 5.43 1 10.65-2.58 11.66-8.01l14.6-78.66c.12-.62.17-1.23.17-1.84 0-.92-.13-1.82-.37-2.68 17.69 9.74 29.68 28.56 29.68 50.18z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m236.808 452c-83.436 0-153.572-43.148-162.952-126.055l-9.24-81.674c-11.626-102.765 68.77-192.771 172.192-192.771 103.422 0 183.819 90.006 172.192 192.772l-9.24 81.674c-9.38 82.906-79.516 126.054-162.952 126.054z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.133 212.167 94.083 94.083h-94.083z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m187.031 259.94c-6.903 0-12.5-5.597-12.5-12.5 0-6.494-5.284-11.778-11.778-11.778-6.495 0-11.778 5.284-11.778 11.778 0 6.903-5.597 12.5-12.5 12.5s-12.5-5.597-12.5-12.5c0-20.279 16.499-36.778 36.778-36.778s36.778 16.499 36.778 36.778c0 6.904-5.597 12.5-12.5 12.5z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.142 259.94c-6.903 0-12.5-5.597-12.5-12.5 0-6.494-5.284-11.778-11.778-11.778-6.495 0-11.778 5.284-11.778 11.778 0 6.903-5.597 12.5-12.5 12.5s-12.5-5.597-12.5-12.5c0-20.279 16.499-36.778 36.778-36.778s36.778 16.499 36.778 36.778c0 6.904-5.597 12.5-12.5 12.5z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m333.92 52.388c-11.597 11.597-18.112 27.326-18.112 43.727v14.885c0 25.932 10.301 50.801 28.638 69.138l29.075 29.075c7.227 7.227 17.029 11.287 27.25 11.287 21.284 0 38.537-17.254 38.537-38.537v-43.599c0-32.247-12.81-63.173-35.612-85.976-19.268-19.268-50.508-19.268-69.776 0z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.411 202.179c19.618 24.16 58.242 24.16 86.268 0 36.602-31.552 81.883-49.278 125.881-49.278 8.319 0 15.713 3.351 20.557 9.317 10.087 12.423 29.946 12.423 44.357 0l5.912-5.096c32.503-28.019 40.409-73.447 17.657-101.466-28.936-35.636-73.109-55.656-122.802-55.656-46.502 0-94.36 18.735-133.046 52.083-19.822 17.087-47.407 13.473-55.918-7.326-2.48-6.06-12.084-3.518-13.309 3.523l-4.956 28.478c-8.187 47.042 2.388 92.158 29.399 125.421z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.037 337.944h-18.458c-15.383 0-27.029-13.901-24.335-29.046l10.581-84.398h45.966l10.581 84.398c2.694 15.145-8.952 29.046-24.335 29.046z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m411.293 302.57-2.97 26.24c-1.96 17.39-6.49 33.92-13.18 49.24-9.95 22.83-24.7 42.98-42.91 59.24-.049.043-.097.087-.146.13-8.958 7.983-20.355 12.666-32.311 13.688-54.364 4.651-108.92 4.652-163.278.001-11.982-1.025-23.396-5.735-32.371-13.74-18.251-16.277-33.032-36.444-43.004-59.32-6.69-15.32-11.22-31.85-13.18-49.24l-2.87-25.35c.003-.004.005-.007.008-.011 16.551-2.804 45.514-5.177 62.152-7.109 16.14-1.88 31.67-6.16 45.81-12.58h.01c40.3-18.27 89.86-18.27 130.16 0l.01.01c14.14 6.41 29.67 10.69 45.81 12.57 14.86 1.731 44.35 3.801 62.26 6.231z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m372.316 330.496c-19.524-1.114-38.321-3.656-55.432-7.464h-.001c-48.762-10.849-108.739-10.849-157.501 0-17.111 3.807-35.908 6.35-55.432 7.464-11.847.676-23.681 1.461-35.504 2.318 2.172 15.925 6.502 31.098 12.676 45.237 9.972 22.876 24.753 43.043 43.004 59.32 1.132 1.01 2.304 1.967 3.51 2.871 73.557 3.454 147.446 3.454 221.003 0 1.184-.889 2.334-1.829 3.447-2.82.049-.043.097-.087.146-.13 18.21-16.26 32.96-36.41 42.91-59.24 6.174-14.139 10.504-29.312 12.676-45.237-11.822-.859-23.655-1.643-35.502-2.319z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.316 361.594c-19.524-.398-38.321-1.306-55.432-2.666h-.001c-48.762-3.875-108.739-3.875-157.501 0-17.111 1.36-35.908 2.268-55.432 2.666-9.61.196-19.208.426-28.801.668 1.74 5.389 3.732 10.658 5.973 15.788 3.346 7.675 7.244 15.036 11.621 22.056 96.674 2.138 194.105 2.138 290.779 0 4.378-7.021 8.276-14.383 11.62-22.056 2.24-5.13 4.232-10.4 5.973-15.788-9.592-.242-19.189-.472-28.799-.668z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m85.267 295.669-14.604-78.656c-1.008-5.43-6.227-9.015-11.658-8.006-5.43 1.008-9.015 6.227-8.006 11.658l14.604 78.656c1.008 5.43 6.227 9.015 11.658 8.006 5.43-1.009 9.014-6.228 8.006-11.658z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.999 295.669 14.604-78.656c1.008-5.43 6.227-9.015 11.658-8.006 5.43 1.008 9.015 6.227 8.006 11.658l-14.604 78.656c-1.008 5.43-6.227 9.015-11.658 8.006-5.43-1.009-9.015-6.228-8.006-11.658z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m402.831 296.068c-16.971-2.805-33.98-5.172-51.015-7.105-16.541-1.877-32.466-6.16-46.963-12.573h-.001c-41.312-18.276-92.126-18.276-133.438 0-14.497 6.413-30.422 10.696-46.963 12.573-17.035 1.933-34.044 4.3-51.016 7.105-6.952 1.149-11.91 5.895-11.91 11.369 0 4.094.358 8.016.79 11.254.589 4.42 5.784 7.509 11.336 6.766 16.284-2.178 36.795-4.061 50.8-5.65 16.541-1.877 32.466-6.16 46.963-12.573 41.312-18.275 92.126-18.275 133.438 0h.001c14.497 6.413 30.422 10.696 46.963 12.573 14.005 1.589 34.515 3.472 50.799 5.65 5.552.743 10.747-2.347 11.336-6.766.431-3.237.79-7.159.79-11.254 0-5.474-4.958-10.22-11.91-11.369z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.099 290.03c20.124-4.144 41.943-4.144 62.068 0 5.784 1.191 11.429-2.254 11.429-6.972v-2.856c0-3.159-2.603-5.959-6.428-6.892-23.126-5.643-48.944-5.643-72.069 0-3.825.933-6.428 3.732-6.428 6.892v2.856c-.001 4.718 5.644 8.163 11.428 6.972z",
    fill: "url(#SVGID_19_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m461.321 388.401c-4.874 46.432-45.753 85.133-95.563 88.652-85.904 6.085-171.996 6.085-257.9 0-55.621-3.931-100.304-51.937-95.724-105.571l17.157-201.052c137.22 26.204 277.813 26.204 415.033 0l17.157 201.052c.492 5.721.421 11.382-.16 16.919z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.321 388.401c-4.874 46.432-45.753 85.133-95.563 88.652-85.904 6.085-171.996 6.085-257.9 0-55.621-3.931-100.304-51.937-95.724-105.571l17.157-201.052c137.22 26.204 277.813 26.204 415.033 0l17.157 201.052c.492 5.721.421 11.382-.16 16.919z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.318 388.4c-4.87 46.43-45.75 85.13-95.56 88.65-13.91.99-27.83 1.82-41.76 2.48l-295.84-295.85 1.13-13.25c137.22 26.2 277.82 26.2 415.04 0l17.15 201.05c.49 5.72.42 11.38-.16 16.92z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m443.035 131.157c-136.384 24.61-276.072 24.61-412.456-.001l-.085-.015c-4.165-.761-8.222 1.636-8.928 5.454l-2.508 24.638c-.654 6.428 1.17 12.863 5.099 17.991 3.852 5.027 9.448 8.418 15.681 9.546 129.459 23.433 264.483 23.435 393.941 0 6.232-1.128 11.828-4.519 15.68-9.546 3.93-5.128 5.753-11.563 5.099-17.991l-2.508-24.638c-.706-3.817-4.763-6.214-8.928-5.454z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.663 163.537c27.33 5.441 56.961 5.441 84.291 0 7.855-1.564 15.521 2.96 15.521 9.154v3.75c0 4.148-3.536 7.824-8.73 9.049-31.406 7.409-66.468 7.409-97.873 0-5.194-1.225-8.73-4.9-8.73-9.049v-3.75c-.001-6.194 7.666-10.718 15.521-9.154z",
    fill: "url(#SVGID_24_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 414.504,
    cy: 414.504,
    fill: "url(#SVGID_25_)",
    r: 95.496
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.613 432c8.219 44.384 47.127 78 93.891 78s85.672-33.616 93.891-78z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.426 397.171-28.087-28.173c-.338-.338-.698-.638-1.051-.949l-93.323 93.323 46.865 46.865c43.972-8.548 77.169-47.26 77.169-93.732.001-5.921-.542-11.713-1.573-17.334z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.284 367.998-39.956 39.956c-2.946 2.946-7.722 2.946-10.668 0l-14.937-14.937c-8.852-8.852-23.204-8.852-32.055 0-8.852 8.852-8.852 23.204 0 32.055l35.681 35.681c9.193 9.193 24.097 9.193 33.289 0l60.701-60.701c8.852-8.852 8.852-23.204 0-32.055-8.851-8.851-23.203-8.851-32.055.001z",
    fill: "url(#SVGID_28_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaceShield);
export default __webpack_public_path__ + "static/media/icon-face-shield.0996e537bfc4b904b8ca304e7eb5220e.svg";
export { ForwardRef as ReactComponent };